import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { Link, NavLink } from 'react-router-dom';

// Assets
import { ReactComponent as FavoritesIcon } from '../../../../assets/images/svg/favorites-icon.svg';
import { ReactComponent as BellIcon } from '../../../../assets/images/svg/bell.svg';
// import { ReactComponent as SubscribeIcon } from '../../../../assets/images/svg/subscribe.svg';
import './ToolBar.scss';
import { useTranslation } from 'react-i18next';
import { Badge } from '@mui/material';

import { GROUP_NAME_EXTERNAL } from '../../../../constants/configuration.js';
import { FETCH_STATUS_LOADING } from '../../../../../features/constants';

// Components
import SearchBarContainer from '../../../../containers/SearchBarContainer';
import AvatarContainer from '../../../../containers/AvatarContainer';
import ProfileDropdownContainer from '../../../../containers/ProfileDropdownContainer';
import { openPushNotification, getUserPushesList, getPushes } from '../../../../../features/user/userSlice';
import PushNotifications from '../../../pushNotifications';

const ToolBar = ({ isAuthorized, location, user, isLoading, isUserInternal, isDesktop }) => {
  const { t } = useTranslation();
  const [isNewNotifications, setIsNewNotifications] = useState(false);
  const dispatch = useDispatch();
  const { list, next_page_url, status } = useSelector(getUserPushesList);

  const getMessages = useCallback(async (page) => {
    try {
      unwrapResult(await dispatch(getPushes(page)));
    } catch (e) {
      console.log(e);
    }
  }, [dispatch]);

  const handleCloseMessages = () => {
    getMessages();
    dispatch(openPushNotification(false));
  };

  const handleNotification = () => {
    getMessages();
    dispatch(openPushNotification(true));
  };

  return (
    <ul className="ToolBar">
      {isAuthorized && isDesktop && user?.groups && user?.groups[0].name === GROUP_NAME_EXTERNAL ? (
        <li className="ToolBar__tariffs" style={{ marginRight: 0 }}>
          <Link className="ToolBar__unfilled" to="/tariffs">{t('header.tariffsBtn')}</Link>
        </li>
      ) : null}
      {isAuthorized && (
        <li className="ToolBar__item ToolBar__favorites">
          <NavLink to="/favorites">
            <FavoritesIcon />
            <span>{t('header.toolbar.watch')}</span>
          </NavLink>
        </li>
      )}
      {/* {isAuthorized && isDesktop && user?.groups?.[0].name === GROUP_NAME_EXTERNAL && (
        <li className="ToolBar__item ToolBar__subscribe">
          <Link to="/subscribe">
            <SubscribeIcon />
            <span>{t('header.toolbar.subscribe')}</span>
          </Link>
        </li>
      )} */}
      <li className="ToolBar__search">
        <SearchBarContainer />
      </li>
      {isAuthorized && (
        <li className="ToolBar__notifications">
          <span onClick={handleNotification}>
            <BellIcon />
            <Badge className="custom-badge" color="error" variant="dot" invisible={!isNewNotifications} />
          </span>
        </li>
      )}
      {!isAuthorized && !isUserInternal && isLoading && (
        <li className="ToolBar__tariffs">
          <Link to="/tariffs">{t('header.tariffsBtn')}</Link>
        </li>
      )}
      <li className="ToolBar__login">
        {isAuthorized ? (
          <>
            {isDesktop ? (
              <>
                <Link className="ToolBar__avatar" to="/profile">
                  <AvatarContainer />
                </Link>
                <ProfileDropdownContainer />
              </>
            ) : (
              <Link className="ToolBar__avatar" to="/profile">
                <AvatarContainer />
              </Link>
            )}
          </>
        ) : (
          <Link
            className="ToolBar__enter"
            to={{
              pathname: '/auth/login',
              state: { background: location }
            }}
          >
            {t('header.loginBtn')}
          </Link>
        )}
      </li>
      {isAuthorized && (
        <PushNotifications
          pushNotifications={list}
          nextPageUrl={next_page_url}
          isNotificationsLoading={status === FETCH_STATUS_LOADING}
          getMessages={getMessages}
          handleClose={handleCloseMessages}
          setIsNewMessages={setIsNewNotifications}
        />
      )}
    </ul>
  );
};

ToolBar.propTypes = {
  isDesktop: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isAuthorized: PropTypes.bool.isRequired,
  statusIsAuthorized: PropTypes.bool.isRequired,
  isUserInternal: PropTypes.bool.isRequired,
  user: PropTypes.object,
  location: PropTypes.object.isRequired
};

export default ToolBar;
